import React from 'react';
import { useIntl } from 'react-intl';
import { Input } from 'semantic-ui-react';

const VocabularyLinkInput = ({
  text,
  type,
  maxLength,
  onChange,
  fluid,
  error,
}) => {
  const intl = useIntl();
  return (
    <Input
      error={error}
      fluid={fluid}
      className="aridhia-vocabulary-link-input"
      value={text || ''}
      maxLength={maxLength}
      placeholder={intl.formatMessage({ id: `vocabulary.link.${type}.placeholder` })}
      onChange={(e, { value }) => { onChange(value); }}
    />
  );
};

export default VocabularyLinkInput;
